export default {};
throw new Error(`Could not resolve "@chakra-ui/react" imported by "@appletosolutions/reactbits". Is it installed?`)